export default __webpack_public_path__ + "static/media/exit-icon.acd7aac6.png";